import React from 'react';
import addModifiers from 'utils/add_modifiers';

const LoadingText = props => (
  <div
    className="Placeholder-text"
    style={{
      width: `${props.width}%`,
    }}
  />
);

const LoadingInput = props => (
  <div
    className="Placeholder-input mr-8"
    style={{
      width: `${props.width}%`,
    }}
  >
    <LoadingText width={props.textWidth} />
  </div>
);

const LoadingRule = props => (
  <div className="Rule d-f">
    <LoadingInput width="30" textWidth={props.textWidth1} />
    <LoadingInput width={props.inputWidth} textWidth={props.textWidth2} />
    <LoadingInput width="30" textWidth={props.textWidth3} />
  </div>
);

const RuleDivider = <div className="RuleDivider-line mt-16 mb-16" />;

const LoadingRuleSet = props => (
  <div>
    <div className="RuleSet">
      <LoadingRule
        textWidth1="75"
        textWidth2="50"
        textWidth3="60"
        inputWidth="15"
      />
      {RuleDivider}
      <LoadingRule
        textWidth1="25"
        textWidth2="65"
        textWidth3="40"
        inputWidth="35"
      />
      {RuleDivider}
      <LoadingRule
        textWidth1="45"
        textWidth2="35"
        textWidth3="80"
        inputWidth="25"
      />
      {RuleDivider}
    </div>
    {RuleDivider}
  </div>
);

class ModalTakeoverLoadingState extends React.Component {
  render() {
    const { editing } = this.props;

    return (
      <div>
        <div className="ModalTakeover-header">
          <div className="ModalTakeover-title">
            {editing
              ? t('smart_groups.create_modal.edit_title')
              : t('smart_groups.create_modal.new_title')}
          </div>
          <div className="mb-8">{t('groups.group_name')}</div>
          <LoadingInput width="100" textWidth="35" />
        </div>
        <div className="ModalTakeover-main">
          <div className="fz-bigger mb-32 c-brand-gray-darker">
            {t('smart_groups.create_modal.instructions')}
          </div>
          <LoadingRuleSet />
          <div className="ModalTakeover-buttonContainer d-f ai-fe jc-sb">
            <div className="ModalTakeover-buttons ml-a">
              <button
                type="button"
                className={addModifiers('NewButton', ['tallAndWide', 'flat'])}
                disabled
              >
                {t('common.cancel')}
              </button>
              <button
                type="button"
                className={addModifiers('NewButton', ['tallAndWide', 'blue'])}
                disabled
              >
                {editing ? t('groups.save_group') : t('groups.create_group')}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ModalTakeoverLoadingState;
